$(document).on('ready', function() {
      $('.autoplay').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 0,
  dots: false,
  arrows: false,
  speed: 5000,
  cssEase: 'linear',
     responsive: [{
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2
            }
        },
          {
            breakpoint: 580,
            settings: {
                slidesToShow: 1,
        dots: false
            }
        }]
});
    });